/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-roles';

export const EntityRoleApi = {
  findEntityRoles: async (option: any) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
};
